import { Link } from "react-router-dom";
import { Crown, Lock } from "lucide-react";

/**
 * Shown when a guest exhausts their free per-feature tries, or a free user
 * hits the combined free limit. `mode` is "guest" | "free".
 */
export const LimitModal = ({ mode, onClose, freeMessage }) => {
  if (!mode) return null;
  return (
    <div
      className="fixed inset-0 z-[60] bg-canvas/80 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="limit-modal"
    >
      <div className="glass-card rounded-3xl max-w-sm w-full p-8 text-center" onClick={(e) => e.stopPropagation()}>
        <div className="w-14 h-14 rounded-full border border-gold/40 flex items-center justify-center mx-auto">
          {mode === "free" ? <Crown className="w-6 h-6 text-gold" /> : <Lock className="w-6 h-6 text-gold" />}
        </div>
        {mode === "guest" ? (
          <>
            <h3 className="font-serif text-2xl text-ink mt-5">You&apos;ve used your free tries</h3>
            <p className="text-sm text-inkmuted mt-2">
              Guests get 3 free tries on each feature. Create a free account to unlock 30 free across all features — or subscribe for unlimited.
            </p>
            <div className="flex flex-col gap-3 mt-7">
              <Link to="/register" data-testid="limit-register-btn" className="rounded-full bg-btn text-btnink hover:bg-btnhover px-6 py-3 text-sm font-semibold uppercase tracking-wider">Create Free Account</Link>
              <Link to="/login" data-testid="limit-login-btn" className="rounded-full bg-surface border border-hairline text-ink hover:bg-surface2 px-6 py-3 text-sm font-semibold uppercase tracking-wider">Sign In</Link>
            </div>
          </>
        ) : (
          <>
            <h3 className="font-serif text-2xl text-ink mt-5">Free limit reached</h3>
            <p className="text-sm text-inkmuted mt-2">{freeMessage || "You've used all your free messages. Subscribe to continue with unlimited access to all features."}</p>
            <div className="flex flex-col gap-3 mt-7">
              <Link to="/pricing" data-testid="limit-subscribe-btn" className="rounded-full bg-btn text-btnink hover:bg-btnhover px-6 py-3 text-sm font-semibold uppercase tracking-wider">View Plans</Link>
              <button onClick={onClose} className="text-inkfaint hover:text-ink text-sm">Maybe later</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
